import "@fontsource/space-grotesk/latin-400.css";
import "@fontsource/space-grotesk/latin-500.css";
import "@fontsource/space-grotesk/latin-600.css";
import "@fontsource/space-grotesk/latin-700.css";
import "@fontsource/dm-mono/latin-400.css";
import "@fontsource/dm-mono/latin-500.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import "./styles.css";

const root = document.getElementById("root");
if (!root) {
  throw new Error("The application root is missing.");
}

if (!supportsRequiredBrowserFeatures()) {
  const heading = root.querySelector<HTMLElement>("[data-boot-heading]");
  const status = root.querySelector<HTMLElement>("[data-boot-status]");
  if (heading) heading.textContent = "This screen needs a newer browser";
  if (status) {
    status.textContent =
      "Secret Cabinet cannot render the live chamber safely here. Use a current phone, computer, or TV browser.";
  }
  root.querySelector<HTMLElement>("[data-boot-progress]")?.remove();
} else {
  createRoot(root).render(
    <StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </StrictMode>,
  );
}

function supportsRequiredBrowserFeatures(): boolean {
  return (
    typeof window.CSS?.supports === "function" &&
    window.CSS.supports("color", "oklch(70% 0.17 28)") &&
    window.CSS.supports("color", "color-mix(in oklch, red, blue)")
  );
}
